import { __assign } from "tslib";
import { createCsatSettingsApi } from './index';
import { createHttpTestKit } from '../../http/test-kit';
import { createFakeGetResponder, createFakePutResponder } from '../../test-utils';
export var createCsatSettingsApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createCsatSettingsApi('', fakeHttp);
    var testKit = {
        whenGetGeneralSettings: function () { return createFakeGetResponder(fakeHttp, "/csat"); },
        whenEnableLocale: function (locale) { return createFakePutResponder(fakeHttp, "/csat/" + locale + "/enable")(undefined); },
        whenDisableLocale: function (locale) { return createFakePutResponder(fakeHttp, "/csat/" + locale + "/disable")(undefined); },
        whenSetCsatDelay: function (delayMinutes) { return createFakePutResponder(fakeHttp, "/csat/delay")({ delayMinutes: delayMinutes }); },
        whenSetCsatThrottling: function (throttlingMinutes) {
            return createFakePutResponder(fakeHttp, "/csat/throttling")({ throttlingMinutes: throttlingMinutes });
        },
        whenSetCsatConditions: function (dto) {
            return createFakePutResponder(fakeHttp, "/csat/throttling")(dto);
        },
        whenSetDisableMultipleCsatsPerTicket: function (enabled) {
            return createFakePutResponder(fakeHttp, "/csat/multipleCsats/enable")({ enabled: enabled });
        },
        whenGetLocaleSettings: function (locale) {
            return createFakeGetResponder(fakeHttp, "/csat/" + locale);
        },
        whenGetDefaultTranslations: function (locale) {
            return createFakeGetResponder(fakeHttp, "/apps/survey/translations/" + locale);
        },
        whenEnableChannel: function (dto) {
            if (dto === '*') {
                return createFakePutResponder(fakeHttp, "*")(dto);
            }
            else {
                return createFakePutResponder(fakeHttp, "/csat/" + dto.locale + "/channel/enable")({ channel: dto.channel, enabled: true });
            }
        },
        whenDisableChannel: function (dto) {
            if (dto === '*') {
                return createFakePutResponder(fakeHttp, "*")(dto);
            }
            else {
                return createFakePutResponder(fakeHttp, "/csat/" + dto.locale + "/channel/enable")({ channel: dto.channel, enabled: false });
            }
        },
        whenSetInvitationMessage: function (dto) {
            if (dto === '*') {
                return createFakePutResponder(fakeHttp, "*")(dto);
            }
            else {
                return createFakePutResponder(fakeHttp, "/csat/" + dto.locale + "/invitationMessage")({ channel: dto.channel, invitationMessage: dto.message });
            }
        },
        whenSetCsatSurveyContent: function (dto) {
            if (dto === '*') {
                return createFakePutResponder(fakeHttp, "*")(dto);
            }
            else {
                return createFakePutResponder(fakeHttp, "/csat/" + dto.locale + "/content")({ content: dto.content });
            }
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map